export default /* @ngInject */ function($q, authService, getOptionsDebounce) {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$options = getOptionsDebounce();
            ngModel.$asyncValidators.email_available = (value) => {
                return $q((resolve, reject) => {
                    authService.isEmailRegistered({email: value})
                        .then(reject) // 200 -> error, already taken
                        .catch(resolve); // 404 -> continue, available
                });
            };
        }
    };
}



// WEBPACK FOOTER //
// ./forms/validators/email-available.js